export const HEADER = {
	NORMAL: [
		'border-solid border-sm rounded-sm',
		'flex flex-col tablet:flex-row',
		'h-full overflow-hidden w-full',
	],
	ACTIVE: 'bg-[#FFD6E1] hover:bg-[#FFE0E9] active:bg-[#FFD6E1] border-[#A0002E]',
	ACTIVE_CAREFUL: 'bg-[#FFEDF2] hover:bg-[#FFE0E9] active:bg-[#FFD6E1] border-[#A0002E]',
	EXPIRED: 'bg-[#EBECEC] hover:bg-[#E2E4E4] active:bg-[#D8DADA] border-[#767676]',
} as const;
